import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { publicSvgPath } from '@orientaction/utils';

export default makeStyles((theme: Theme) => ({
  gradientBG: {
    backgroundColor: theme.palette.primary.dark,
  },
  noPadding: {
    '&>div': {
      '@media(min-width: 1250px)': {
        padding: '0px !important',
      },
    },
  },
  layout: {
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: theme.palette.primary.dark,
  },
  content: {
    // maxWidth: 'calc(100% - 205px)',
    height: '100%',
    overflow: 'auto',
    zIndex: 1,
    '&>div': {
      // height: 'calc(100vh - 76px)',
      padding: theme.spacing(0, 3),
      color: theme.palette.primary.main,
      overflow: 'auto',
      '@media(min-width: 1750px)': {
        padding: '56px 120px 28px 80px',
      },
    },
  },
  appBar: {
    paddingRight: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    border: '1px solid #E3E8F0',
    '&>button': {
      marginRight: theme.spacing(-2),
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(0),
      height: '60px',
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    marginTop: 10,
    marginBottom: 10,
    '& a': {
      marginRight: theme.spacing(4.75),
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '98.5%',
      marginTop: 0,
      marginBottom: 0,
    },
  },
  logoContainer: {
    cursor: 'pointer',
    maxWidth: 239,
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 165,
    },
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
  profilContainer: {
    display: 'flex',
    alignItems: 'center',
    '& div, hr': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 30,
      },
    },
  },
  btnPrimary: {
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    '@media(min-width: 1250px)': {
      minHeight: 48,
      height: 48,
      width: 146,
      minWidth: 146,
    },
  },
  initial: {
    width: 38,
    height: 38,
    background: '#000A8C 0% 0% no-repeat padding-box',
    borderRadius: '100%',
    color: '#fff',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      height: '51%',
    },
  },
  divider: {
    display: 'none',
    '@media(min-width: 1250px)': {
      display: 'block',
      height: '20px',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  textHeader: {
    display: 'none',
    '@media(min-width: 1250px)': {
      display: 'block',
    },
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 !important',
    cursor: 'pointer',
    '& > span': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 30,
      },
    },
  },
  colorPrimary: {
    backgroundColor: '#CDCEDA',
    height: '8px',
    borderRadius: '60px',
  },
  barColorPrimary: {
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    height: '8px',
    borderRadius: '60px',
  },
  progressBar: {
    width: '100%',
    margin: 'auto',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  btnContacter: {
    padding: 25,
    background: '#e63c3c',
    color: 'white',
    borderRadius: '50px',
    transition: 'all 1s ease',
    fontSize: '12px',
    '&:hover': {
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    },
  },
  btnIcon: {
    border: '1px solid grey',
    borderRadius: '5px !important',
    width: 32,
    height: 32,
    padding: '2px',
    margin: '0 2vh',
  },
  styleIcon: {
    color: '#0E1247',
    width: '20px',
    height: '20px',
  },
  flexCenterMobile: {
    '@media only screen and (max-width: 600px)': {
      justifyContent: 'flex-end',
    },
    '@media only screen and (max-width: 361px)': {
      justifyContent: 'flex-end',
    },
  },
  flex: {
    display: 'flex',
    width: '100%',
  },
  topLineContainer: {
    position: 'fixed',
    top: 71,
    right: 0,
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/top_line.svg)`,
    backgroundRepeat: 'no-repeat',
    width: 611,
    height: 574,
    zIndex: 0,
    [theme.breakpoints.down('md')]: {
      top: -64,
      right: -142,
    },
    [theme.breakpoints.down('sm')]: {
      top: -83,
      right: -142,
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/top_line_mobile.svg)`,
      backgroundRepeat: 'no-repeat',
      top: 60,
      right: -236,
      display: 'none',
    },
  },
  bottomLineContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/bottom_line.svg)`,
    backgroundRepeat: 'no-repeat',
    width: 601,
    height: 463,
    zIndex: 0,
    [theme.breakpoints.down('md')]: {
      bottom: -35,
      left: -135,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/bottom_line_mobile.svg)`,
      bottom: -167,
      left: 0,
    },
  },
  rootC: {
    minHeight: '100vh',
  },
}));
